import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { holidayGifts } from "@/mocks/products";

export default function CrowChatSection() {
  const [likedGifts, setLikedGifts] = useState<number[]>([]);
  const navigate = useNavigate();

  const toggleLike = (id: number) => {
    setLikedGifts((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const goToCrowntalk = () => navigate("/crowntalk");

  return (
    <>
      {/* Crowntalk Download Section */}
      <section className="py-10 md:py-14 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">
            {/* Left: App preview - hidden on small mobile, shown on sm+ */}
            <div className="hidden sm:block flex-1 relative w-full">
              <div className="relative w-full max-w-sm mx-auto">
                <img
                  src="https://public.readdy.ai/ai/img_res/025d94ab82ab686e9d6646ad09d91b0b.jpg"
                  alt="Crowntalk App"
                  className="w-full h-auto rounded-2xl object-cover object-top"
                  style={{ maxHeight: "380px" }}
                />
                <div className="absolute -top-3 -right-3 bg-red-500 text-white rounded-xl px-3 py-1.5 text-xs font-bold">
                  <i className="ri-global-line mr-1"></i> 全球互联
                </div>
                <div className="absolute -bottom-3 -left-3 bg-white border border-gray-100 rounded-xl px-3 py-1.5 text-xs font-medium text-gray-700">
                  <i className="ri-video-line mr-1 text-red-500"></i> 高清视频通话
                </div>
              </div>
            </div>

            {/* Right: Info */}
            <div className="flex-1 w-full max-w-lg mx-auto lg:mx-0">
              <div className="flex items-center gap-3 mb-3 md:mb-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png"
                  alt="Crowntalk Logo"
                  className="w-10 h-10 md:w-12 md:h-12 object-contain"
                />
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                    Crowntalk
                  </h2>
                  <p className="text-gray-400 text-xs md:text-sm">皇冠鸿运商城官方全球社交应用</p>
                </div>
              </div>

              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5 md:mb-6">
                Crowntalk 是皇冠鸿运商城推出的全球社交通讯应用，支持与全球任何人进行文字、语音、高清视频通话，
                还可以分享节日礼物、商品推荐，打造属于你的购物社交圈。
              </p>

              <div className="grid grid-cols-2 gap-3 mb-5 md:mb-6">
                {[
                  { icon: "ri-message-3-line", title: "即时通讯", desc: "全球实时消息，毫秒级响应" },
                  { icon: "ri-video-line", title: "高清视频", desc: "1080P 超清视频通话" },
                  { icon: "ri-gift-line", title: "礼物分享", desc: "节日礼品一键分享好友" },
                  { icon: "ri-shield-check-line", title: "安全加密", desc: "端对端加密，隐私保护" },
                ].map((feat) => (
                  <div key={feat.title} className="flex items-start gap-2.5 p-3 bg-red-50 rounded-xl">
                    <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-red-500 rounded-lg flex-shrink-0">
                      <i className={`${feat.icon} text-white text-sm md:text-base`}></i>
                    </div>
                    <div>
                      <p className="text-gray-800 font-semibold text-xs md:text-sm">{feat.title}</p>
                      <p className="text-gray-400 text-xs mt-0.5 hidden sm:block">{feat.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Download buttons */}
              <div className="grid grid-cols-3 gap-2 mb-3">
                <button
                  onClick={goToCrowntalk}
                  className="flex items-center justify-center gap-1.5 bg-gray-900 hover:bg-gray-800 text-white px-3 py-3 rounded-xl font-medium transition-colors cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  <div className="text-left hidden sm:block">
                    <p className="text-xs text-gray-400 leading-none">即将上线</p>
                    <p className="text-xs font-bold leading-tight">App Store</p>
                  </div>
                  <span className="text-xs font-bold sm:hidden">iOS</span>
                </button>
                <button
                  onClick={goToCrowntalk}
                  className="flex items-center justify-center gap-1.5 bg-gray-900 hover:bg-gray-800 text-white px-3 py-3 rounded-xl font-medium transition-colors cursor-pointer"
                >
                  <i className="ri-android-line text-lg text-green-400"></i>
                  <div className="text-left hidden sm:block">
                    <p className="text-xs text-gray-400 leading-none">即将上线</p>
                    <p className="text-xs font-bold leading-tight">Google Play</p>
                  </div>
                  <span className="text-xs font-bold sm:hidden">Android</span>
                </button>
                <button
                  onClick={goToCrowntalk}
                  className="flex items-center justify-center gap-1.5 bg-red-500 hover:bg-red-600 text-white px-3 py-3 rounded-xl font-medium transition-colors cursor-pointer"
                >
                  <i className="ri-download-line text-lg"></i>
                  <div className="text-left hidden sm:block">
                    <p className="text-xs text-red-200 leading-none">安卓直接</p>
                    <p className="text-xs font-bold leading-tight">APK 下载</p>
                  </div>
                  <span className="text-xs font-bold sm:hidden">APK</span>
                </button>
              </div>

              {/* Main CTA */}
              <button
                onClick={goToCrowntalk}
                className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-gray-900 font-bold py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-circle-line text-lg"></i>
                了解 Crowntalk 全部功能 &amp; 下载
              </button>

              <p className="text-gray-400 text-xs mt-3">
                <i className="ri-information-line mr-1"></i>
                支持 iOS 14+ / Android 8.0+ · 华为小米OPPO等国内手机直接安装 · 全球 180+ 国家可用
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Holiday Gift Sharing Section */}
      <section className="py-10 md:py-12 bg-gradient-to-br from-red-600 to-red-800">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-6 md:mb-8">
            <span className="inline-block bg-white/20 text-white text-xs px-3 py-1 rounded-full mb-2 md:mb-3">
              <i className="ri-gift-line mr-1"></i> 节日礼品专区
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              分享节日礼物，传递美好心意
            </h2>
            <p className="text-white/70 text-sm">
              通过 Crowntalk 与全球好友分享节日礼品，一键购买，直达心意
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {holidayGifts.map((gift) => (
              <div
                key={gift.id}
                className="bg-white rounded-xl overflow-hidden cursor-pointer hover:scale-[1.03] transition-transform duration-200"
              >
                <div className="relative">
                  <img
                    src={gift.image}
                    alt={gift.name}
                    className="w-full h-36 md:h-44 object-cover object-top"
                  />
                  <button
                    onClick={() => toggleLike(gift.id)}
                    className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center bg-white/80 rounded-full cursor-pointer"
                  >
                    <i className={`text-sm ${likedGifts.includes(gift.id) ? "ri-heart-fill text-red-500" : "ri-heart-line text-gray-400"}`}></i>
                  </button>
                </div>
                <div className="p-2.5 md:p-3">
                  <p className="text-gray-800 font-medium text-xs md:text-sm mb-1 line-clamp-1">{gift.name}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-red-500 font-bold text-sm">¥{gift.price}</span>
                    <div className="flex items-center gap-1 text-gray-400 text-xs">
                      <i className="ri-heart-line"></i>
                      <span>{(gift.likes + (likedGifts.includes(gift.id) ? 1 : 0)).toLocaleString()}</span>
                    </div>
                  </div>
                  <button className="mt-2 w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg text-xs font-medium transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-share-line mr-1"></i> 分享礼物
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-6 md:mt-8">
            <button
              onClick={goToCrowntalk}
              className="bg-white text-red-500 hover:bg-red-50 px-8 py-3 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-gift-2-line mr-2"></i> 查看全部节日礼品
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
